import SyncIcon from "@mui/icons-material/Sync";
import SyncDisabledIcon from "@mui/icons-material/SyncDisabled";

export const SyncScrollToolConfig = (onToggle, isActive) => ({
  name: "SYNC SCROLL",
  tool: "SyncScrollTool",
  icon: (
    <div onClick={onToggle}>
      {isActive ? <SyncDisabledIcon /> : <SyncIcon />}
    </div>
  ),
});